import * as React from "react"
import { Area } from "../../../types/types";


type Props = {
  area: Area
}

const defaultAreaCtaLabel = (area: Area) => I18n.t("areas.cta.gite.other", { count: area.gitesCount, area: area.name } )

export const LinksToOverview = (props: Props) : JSX.Element => (
  <div className="footer-button tac">
    <div>
      <a href={props.area.giteOverviewPath} id={`${props.area.slug}_area_bottom_cta_gite`} className="btn btn--large btn--primary">
        {props.area.facet ? I18n.t(`areas.cta.gite.${props.area.facet}`, { defaultValue: defaultAreaCtaLabel(props.area) }) : defaultAreaCtaLabel(props.area)}
      </a>
    </div>
    { props.area.bedAndBreakfastsCount ?
      <div>
        <a href={props.area.bnbOverviewPath} id={`${props.area.slug}_area_bottom_cta_bnb`} className="btn btn-link">
          {I18n.t("areas.cta.bnb", { count: props.area.bedAndBreakfastsCount } )}
        </a>
      </div>
      : <></>
    }
  </div>
)
